import React from "react";

const TranslationDocs = () => {
  return (
    <div className="transHeadContent">
      <h2>
        Document <span>Translation</span> Services{" "}
      </h2>
      <p>
        We offer a comprehensive range of document translation services for
        personal, educational, and business records. Personal documents include
        birth certificates, marriage certificates, and other records directly
        related to an individual. Educational records, such as academic
        transcripts, are often required by institutions and employers. Business
        documents include records of ownership and other commercial papers.
      </p>
    </div>
  );
};

export default TranslationDocs;
